export const INVENTORY_CHECK_REMARKS_FIELD_NAME = "remarks";
